// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type GerarCobrancaAssinaturaPayload = {
  pessoaId: number;
  quantidadeCotas: number;
  formaPagamento?: "PIX" | "BOLETO" | "CARTAO";
  planoAssinatura?: "ANUNCIO_PROPRIEDADE";
  enviarWhatsapp?: boolean;
};

export type GerarCobrancaAssinaturaResponse = {
  assinatura: {
    id: number;
    pessoaId: number;
    usuarioId: number;
    cotaUsuarioId: number | null;
    quantidadeCotas: number;
    planoAssinatura: string;
    status: string;
  };
  pagamento: {
    id: number;
    origemTipo: string;
    origemId: number;
    tipo: string;
    status: string;
    valor: number;
    linkPagamento: string;
    gatewayPaymentId: string;
  };
  whatsapp?: {
    tentado: boolean;
    enviado: boolean;
    mensagemId?: number;
    statusMensagem?: string;
  };
};

export const cadastrarAssinaturaService = async (
  data: GerarCobrancaAssinaturaPayload
): Promise<GerarCobrancaAssinaturaResponse> => {
  const Token = validateToken();

  if (!Token) {
    throw new Error("Sessão expirada. Faça login novamente.");
  }

  const URL = `${Globais.DOMINIOBACK}/assinatura/gerar-cobranca`;

  try {
    const response = await axios.post<GerarCobrancaAssinaturaResponse>(
      URL,
      data,
      {
        headers: { Authorization: Token.AuthStr },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
